import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignValidationUserNeed } from '../Product.hooks';
import {
  ProductUserNeed,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignUserNeedDialog from './AssignUserNeedDialog';

export type ValidationAssignUserNeedDialogProps = BaseProductAssignDialogProps<'validationId'>;

const ValidationAssignUserNeedDialog: React.FC<ValidationAssignUserNeedDialogProps> = (
  props: ValidationAssignUserNeedDialogProps
) => {
  const {
    open,
    productId,
    validationId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductValidation,
    isAssigning,
    error: assignError,
    assignUserNeeds
  } = useAssignValidationUserNeed(productId, validationId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductValidation) {
      onAssigned?.(updatedProductValidation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductValidation]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignUserNeedDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'userNeed'
      )} to assign to the ${getProductEntityName('validation')}.`}
      onSubmit={(userNeeds: ProductUserNeed[]) => {
        assignUserNeeds({
          userNeedIds: userNeeds.map((userNeed: ProductUserNeed) => userNeed.id)
        });
      }}
    />
  );
};

export default ValidationAssignUserNeedDialog;
